import { FC } from "react";
import { createPortal } from "react-dom";
import { useNovoPedidoModal } from "../context/NovoPedidoContext";
import { NovoPedidoForm } from "./NovoPedidoForm";

export const NovoPedidoModal: FC = () => {
  const { isOpen, closeNovoPedido, notifySuccess } = useNovoPedidoModal();

  if (!isOpen || typeof document === "undefined") return null;

  return createPortal(
    <>
      <div
        className="modal fade show d-block"
        role="dialog"
        tabIndex={-1}
        style={{ zIndex: 1055 }}
      >
        <div className="modal-dialog modal-dialog-centered modal-xl modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h3 className="modal-title fw-bold">Novo Pedido</h3>
              <button
                type="button"
                className="btn-close"
                aria-label="Fechar"
                onClick={closeNovoPedido}
              />
            </div>
            <div className="modal-body">
              <NovoPedidoForm
                active={isOpen}
                idPrefix="modal-pedido"
                showCancel
                onCancel={closeNovoPedido}
                onSuccess={() => {
                  notifySuccess();
                  closeNovoPedido();
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" style={{ zIndex: 1050 }} />
    </>,
    document.body,
  );
};
